import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})

export class StateService {
  isMapManipulated: boolean = false;
  public isZoomingAutomatically: boolean = false; // Flag to detect zoom initiated by the app
  private userManipulated = false; // Flag to track user manipulation


  // BehaviorSubject to hold and emit the current state
  public currentStateSubject = new BehaviorSubject<ZoomState>(ZoomState.Default);
  // Observable to expose the current state
  currentState$ = this.currentStateSubject.asObservable();
  // BehaviorSubject to hold and emit the selected vehicle
  private selectedMarkerSubject = new BehaviorSubject<any>(null);
  // Observable to expose the selected vehicle
  selectedMarker$ = this.selectedMarkerSubject.asObservable();

  public zoomCounter=0;

  constructor(
    private mapService: MapService,
    private dataManagementService: DataManagementService,
  ) {
    this.updateState(ZoomState.Default);
    this.mapService.mapLoaded.subscribe( e=> {
      setTimeout(() => {
        this.ManipulationMap();
      }, 1000);
    })
  }



  updateState(newState: ZoomState) {
    if (this.getState() !== newState) {
      this.currentStateSubject.next(newState);
    }
    this.handleStateChange(newState);
  }
  // Method to get the current state
  getState(): ZoomState {
    return this.currentStateSubject.getValue();
  }

  // Method to get the current selected vehicle
  getSelectedMarker(): any {
    const value = this.selectedMarkerSubject.getValue();
    return value;
  }

  // Method to set the selected vehicle
  setSelectedMarker(Marker: any) {
    this.selectedMarkerSubject.next(Marker);
  }
  // Method to set the selected vehicle using latitude and longitude
  setSelectedMarkerWith2Parm(latitude: number, longitude: number) {
    const marker = {
      latitude: latitude,
      longitude: longitude,
      coordinate: L.latLng(latitude, longitude) // Optionnel, si tu utilises Leaflet
    };
    this.selectedMarkerSubject.next(marker);
  }




  // Set manipulation state
  setUserManipulationState(isManipulated: boolean) {
    this.userManipulated = isManipulated;
  }

  stopVehicleTracking(): void {
    if (this.trackingInterval) {
      clearInterval(this.trackingInterval);
      this.trackingInterval = null;
    }
  }

  ManipulationMap() {
    this.mapService.map.on('movestart', () => {
      if (this.dataManagementService.selectedVehicule) {
        this.stopVehicleTracking();
        this.zoomCounter++;
        return;
      }
      if (!this.isZoomingAutomatically && !this.userManipulated && this.getState() !== ZoomState.Default) {
        this.setUserManipulationState(true);
        this.updateState(ZoomState.Manipulated);
        // console.log("movestart");
      }
      this.zoomCounter++;
      //console.log("zoomCounter move"+ this.zoomCounter);
    });

    this.mapService.map.on('zoomstart', () => {
      if (this.dataManagementService.selectedVehicule) {
        this.zoomCounter++;
        return;
      }
      if (!this.isZoomingAutomatically && !this.userManipulated && this.getState() !== ZoomState.Default) {
        this.setUserManipulationState(true);
        this.updateState(ZoomState.Manipulated);
        // console.log("zoomstart");
      }
      this.zoomCounter++;
      //console.log("zoomCounter zoom"+ this.zoomCounter);
    });
  }


  // Fonction pour "bound" la carte en fonction de toutes les coordonnées des véhicules

  // Handle state changes
  private trackingInterval: any; // Variable pour stocker l'intervalle
  private handleStateChange(state: ZoomState) {

    this.isZoomingAutomatically = true;  // Disable user detection

    if (this.trackingInterval) {
      clearInterval(this.trackingInterval);
      this.trackingInterval = null; // Réinitialiser l'intervalle
    }

    const selectedMarker = this.getSelectedMarker();

    switch (state) {


      case ZoomState.Manipulated:
        if (!this.dataManagementService.selectedVehicule) {
          this.setSelectedMarker(null);
        }
        break;

      case ZoomState.SelectedVehicule:
        if (selectedMarker) {

            /*if (this.userManipulated) {
                return;
            }*/
          this.isZoomingAutomatically = true;  // Disable user detection
          this.mapService.map.setView(selectedMarker.realTimeRecord.coordinate, 17);
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);
          if (this.getState() !== ZoomState.SelectedVehicule) {
            this.trackingInterval = setInterval(() => {
              const currentCoordinates = this.mapService.map.getCenter();
              const newCoordinates = selectedMarker.realTimeRecord.coordinate;
              if (this.getState() === ZoomState.SelectedVehicule &&
                (currentCoordinates.lat !== newCoordinates.lat || currentCoordinates.lng !== newCoordinates.lng)) {
                this.isZoomingAutomatically = true;  // Disable user detection
                this.mapService.map.setView([newCoordinates.lat, newCoordinates.lng]);
                this.isZoomingAutomatically = false; // Re-enable user detection
                this.setUserManipulationState(false);
              }
            }, 1000);
          }
        }

        break;

      case ZoomState.pointInterest:
        if (selectedMarker) {
          this.isZoomingAutomatically = true;  // Disable user detection
          this.mapService.map.setView(selectedMarker.coordinate, 18);
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);
        } else {
          console.warn('point Interest sélectionné non disponible pour l\'état SelectedVehicule.');
        }
        break;

      case ZoomState.currentPosition:
        if (selectedMarker) {
          this.isZoomingAutomatically = true; // Re-enable user detection
          this.mapService.map.setView(selectedMarker, 15);
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);
        } else {
          console.warn('Position actuelle non disponible pour l\'état currentPosition.');
        }
        break;
      case ZoomState.DisplayPath:
        if (selectedMarker) {
          this.isZoomingAutomatically = true; // Re-enable user detection
          this.mapService.map.setView([selectedMarker.latitude, selectedMarker.longitude], 17);
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);
        }
        else {
          console.warn('Position actuelle non disponible pour l\'état displaypath.');
        }
        break;


      case ZoomState.ponitSpeed:
        if (selectedMarker) {
          this.isZoomingAutomatically = true; // Re-enable user detection
          this.mapService.map.setView(selectedMarker, 17);
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);

        } else {
          console.warn('Position actuelle non disponible pour l\'état ponitSpeed.');
        }
        break;

      case ZoomState.Stop:
        if (selectedMarker) {
          this.isZoomingAutomatically = true; // Re-enable user detection
          this.mapService.map.setView(
            { lat: selectedMarker.stopLatitude, lng: selectedMarker.stopLongitude },
            15
          );
          this.isZoomingAutomatically = false; // Re-enable user detection
          this.setUserManipulationState(false);
        } else {
          console.warn('Position actuelle non disponible pour l\'état ponitSpeed.');
        }
        break;


      case ZoomState.Default:
        this.mapService.boundAllVehicles();
        this.setSelectedMarker(null);
        break;





    }
    setTimeout(() => {
      this.isZoomingAutomatically = false; // Re-enable user detections
    }, 100);

  }

}



export enum ZoomState {
  currentPosition = 'currentPosition',
  SelectedVehicule = 'SelectedVehicule',
  pointInterest = 'pointInterest',
  Stop = 'Stop',
  ponitSpeed = 'ponitSpeed',
  DisplayPath = 'DisplayPath',
  Default = 'Default',
  Manipulated = 'Manipulated',
  TodayPath = 'TodayPath',
  currentpath = 'currentpath',
}
